export default __webpack_public_path__ + "static/media/smart2.e37459e8.PNG";